<template>
    <StyleModal
        :widthXs="width_xs"
        :maxWidthSm="max_width_sm"
        :maxWidthMd="max_width_md"
        :maxWidthLg="max_width_lg"
        :maxWidthXl="max_width_xl"
    >
        <div
            class="modal fade"
            :id="modal_id"
            :aria-labelledby="modal_id"
            aria-hidden="true"
        >
            <div class="modal-dialog">
                <div class="modal-content" :id="'content-' + modal_id">
                    <div v-if="has_header" class="modal-header">
                        <slot name="header"></slot>
                        <button
                            type="button"
                            class="close"
                            @click.prevent="$root.closeModalApp(modal_id)"
                        >
                            &times;
                        </button>
                    </div>
                    <div class="modal-body">
                        <slot></slot>
                    </div>
                    <div v-if="has_footer" class="modal-footer">
                        <slot name="footer"></slot>
                    </div>
                </div>
            </div>
        </div>
    </StyleModal>
</template>

<script>
import { StyleModal } from "./style";

export default {
    name: "ToastConfirm",
    props: {
        modal_id: {
            required: true
        },
        has_header: {
            default: true
        },
        has_footer: {
            default: false
        },
        width_xs: {
            default: "100%"
        },
        max_width_sm: {
            default: "500px"
        },
        max_width_md: {
            default: "500px"
        },
        max_width_lg: {
            default: "800px"
        },
        max_width_xl: {
            default: "800px"
        }
    },
    components: {
        StyleModal
    }
};
</script>
